var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6Z",
    fill: "#E22121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52538 2.493V5.067C6.52538 5.34 6.51188 5.6085 6.48488 5.8725C6.45788 6.1335 6.42338 6.411 6.38138 6.705H5.62538C5.58338 6.411 5.54888 6.1335 5.52188 5.8725C5.49488 5.6085 5.48138 5.34 5.48138 5.067V2.493H6.52538ZM5.30588 8.388C5.30588 8.295 5.32238 8.2065 5.35538 8.1225C5.39138 8.0385 5.43938 7.9665 5.49938 7.9065C5.56238 7.8465 5.63588 7.7985 5.71988 7.7625C5.80388 7.7265 5.89388 7.7085 5.98988 7.7085C6.08288 7.7085 6.17138 7.7265 6.25538 7.7625C6.33938 7.7985 6.41138 7.8465 6.47138 7.9065C6.53438 7.9665 6.58388 8.0385 6.61988 8.1225C6.65588 8.2065 6.67388 8.295 6.67388 8.388C6.67388 8.484 6.65588 8.574 6.61988 8.658C6.58388 8.739 6.53438 8.8095 6.47138 8.8695C6.41138 8.9295 6.33938 8.976 6.25538 9.009C6.17138 9.045 6.08288 9.063 5.98988 9.063C5.89388 9.063 5.80388 9.045 5.71988 9.009C5.63588 8.976 5.56238 8.9295 5.49938 8.8695C5.43938 8.8095 5.39138 8.739 5.35538 8.658C5.32238 8.574 5.30588 8.484 5.30588 8.388Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.0f262b8da2a0c5dc8d4a2f7aba1674ce.svg";
export { ForwardRef as ReactComponent };